import classNames from 'classnames'
import styles from './Menu.module.css'
import { useTranslation } from 'react-i18next'
import Globe from '../../../assets/globe.svg?react'
import Language from '../../../assets/language.svg?react'
import Tutorial from '../../../assets/tutorial.svg?react'
import LogoMenu from '../../../assets/logo-menu.svg?react'
import LoginWhite from '../../../assets/login-white.svg?react'
import Donation from '../../../assets/donation.svg?react'
import WikiSurvey from '../../../assets/survey_white.svg?react'
import ScrapingWhite from '../../../assets/scraping-white.svg?react'
import Credits from '../../../assets/credits.svg?react'
import { usePaeseContext } from '../../../context/PaeseContext'
import { useAuthActions, useAuthUser } from 'use-eazy-auth'
import { useLocation } from 'react-router-dom'
import { useDonationContext } from '../../../context/DonationContext'
import { getActiveGeocontext } from '../../../utils'
import { useEffect, useMemo, useState } from 'react'
import { useQsFilters } from '../../../hooks/filters'
import { useTopContextState } from '../../../context/TopContext'
import { useLingue } from '../../../hooks/languages'

const getFilters = (params: URLSearchParams) => ({
  search: params.get('search') ?? '',
  municipality: params.get('municipality') ?? '',
  ordering: params.get('ordering') ?? 'label',
  in_contest: params.get('in_contest') ?? 'true',
  only_without_pictures: params.get('only_without_pictures') ?? '',
  app_category: params.get('app_category') ?? '',
  user_lat: Number(params.get('user_lat')) ?? '',
  user_lon: Number(params.get('user_lon')) ?? '',
  monument_lat: Number(params.get('monument_lat')) ?? '',
  monument_lon: Number(params.get('monument_lon')) ?? '',
  map_zoom: Number(params.get('map_zoom')) ?? '',
  map_lat: Number(params.get('map_lat')) ?? '',
  map_lon: Number(params.get('map_lon')) ?? '',
  monument_id: Number(params.get('monument_id')) ?? '',
  geo_context: params.get('geo_context') ?? '',
  cluster_active: params.get('cluster_active') ?? '',
  only_disabled: params.get('only_disabled') ?? '',
  without_coordinates: params.get('without_coordinates') ?? '',
})

export default function Menu({
  setModalLang,
  setPresentazione,
  setInfoWiki,
  setModalPaese,
  setProfileOpen,
  setScrapingOpen,
  setScrapingOsmOpen,
  scrapingOsmOpen,
  scrapingOpen,
  scrapingCommonsOpen,
  setScrapingCommonsOpen,
  setShowCredits,
  setShowLicenseModal,
}: {
  setModalLang: (value: boolean) => void
  setPresentazione: (value: boolean) => void
  setInfoWiki: (value: boolean) => void
  setModalPaese: (value: boolean) => void
  setProfileOpen: (value: boolean) => void
  setScrapingOpen: (value: boolean) => void
  setScrapingOsmOpen: (value: boolean) => void
  scrapingOsmOpen: boolean
  scrapingOpen: boolean
  scrapingCommonsOpen: boolean
  setScrapingCommonsOpen: (value: boolean) => void
  setShowCredits: (value: boolean) => void
  setShowLicenseModal: (value: boolean) => void
}) {
  const { filters, setFilters } = useQsFilters(getFilters)
  const { t, i18n } = useTranslation()
  const { country } = usePaeseContext()
  const { user } = useAuthUser()
  const username = user ? user.username.replace('mw--', ' ') : ''
  const { logout } = useAuthActions()
  const { pathname, search } = useLocation()
  const { setDonationModal } = useDonationContext()
  const activeGeocontext = getActiveGeocontext()
  const { data: lingue, refetch: refetchLingue } = useLingue()

  useEffect(() => {
    refetchLingue()
  }, [user, refetchLingue])

  const currentLang = useMemo(() => {
    return lingue?.find((l) => l.code === i18n.language)
  }, [i18n.language, lingue, t])

  const [coord, setCoord] = useState<{ lat: number; lon: number }>({
    lat: 0,
    lon: 0,
  })

  function success(position: any) {
    const latitude = position.coords.latitude
    const longitude = position.coords.longitude
    setCoord({ lat: latitude, lon: longitude })
  }

  function error() {
    setCoord({ lat: 0, lon: 0 })
    console.log('Unable to retrieve your location')
  }

  const { geoPermission } = useTopContextState()

  useEffect(() => {
    if (navigator.geolocation && geoPermission !== 'denied') {
      navigator.geolocation.getCurrentPosition(success, error)
    } else {
      console.log('Geolocation not supported')
    }
  }, [])

  const urlLimeSurvey = useMemo(() => {
    // if (!activeGeocontext?.survey_link) return ''
    // if (!username) return ''
    const url = activeGeocontext?.survey_link
    const lat = coord.lat || filters.user_lat || 0
    const lon = coord.lon || filters.user_lon || 0
    const lang = i18n.language
    const user = username.replace(' ', '')
    const contest = activeGeocontext?.country_code
    return `${url}?lang=${lang}&user=${user}&contest=${contest}&lat=${lat}&lon=${lon}`
  }, [
    activeGeocontext,
    i18n.language,
    username,
    filters.user_lat,
    filters.user_lon,
    coord.lat,
    coord.lon,
  ])

  return (
    <div
      className={styles.Menu}
      style={{
        height:
          username &&
          user.is_superuser &&
          user.admin_geo_contexts.includes(activeGeocontext?.id)
            ? '720px'
            : '590px',
      }}
    >
      <div className="d-flex flex-column justify-content-between h-100">
        <div>
          <div className={styles.TitleMenu}>{t('GENERIC_WLM')}</div>
          <div className={styles.SloganUser}>
            {t('MENU_WELCOME_PROMPT')} {username ? `, ${username}!` : '!'}
          </div>
          <div className="mt-2">
            <div
              className={styles.ListItemMenu}
              onClick={() => setModalPaese(true)}
            >
              <Globe className="me-3" />{' '}
              <div>
                <div>{t('GENERIC_COUNTRY')}</div>
                <div className={styles.ListItemOptionSelected}>
                  {country.label}
                </div>
              </div>
            </div>
            <div
              className={classNames(styles.ListItemMenu, 'mt-2')}
              onClick={() => setModalLang(true)}
            >
              <Language className="me-3" />{' '}
              <div>
                <div>{t('MENU_LANGUAGE')}</div>
                <div className={styles.ListItemOptionSelected}>
                  {currentLang?.name}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          {username &&
            user.is_superuser &&
            user.admin_geo_contexts.includes(activeGeocontext?.id) && (
              <div
                className={classNames(styles.ListItemMenu, 'mt-2')}
                onClick={() => {
                  setProfileOpen(false)
                  setScrapingOsmOpen(!scrapingOsmOpen)
                  setScrapingOpen(false)
                  setScrapingCommonsOpen(false)
                }}
              >
                <ScrapingWhite className="me-3" />
                Scraping OSM
              </div>
            )}
          {username &&
            user.is_superuser &&
            user.admin_geo_contexts.includes(activeGeocontext?.id) && (
              <div
                className={classNames(styles.ListItemMenu, 'mt-3')}
                onClick={() => {
                  setProfileOpen(false)
                  setScrapingOpen(!scrapingOpen)
                  setScrapingOsmOpen(false)
                  setScrapingCommonsOpen(false)
                }}
              >
                <ScrapingWhite className="me-3" />
                Scraping Wikidata
              </div>
            )}
          {username &&
            user.is_superuser &&
            user.admin_geo_contexts.includes(activeGeocontext?.id) && (
              <div
                className={classNames(styles.ListItemMenu, 'mt-3')}
                onClick={() => {
                  setProfileOpen(false)
                  setScrapingOpen(false)
                  setScrapingOsmOpen(false)
                  setScrapingCommonsOpen(!scrapingCommonsOpen)
                }}
              >
                <ScrapingWhite className="me-3" />
                Scraping Commons
              </div>
            )}
          {urlLimeSurvey && urlLimeSurvey !== '' && (
            <a
              className={classNames(styles.ListItemMenu, 'mt-3')}
              href={urlLimeSurvey}
              target="_blank"
              rel="noopener noreferrer"
            >
              <WikiSurvey width={24} className="me-3" />{' '}
              {t('MENU_REPORT_SOMETHING')}
            </a>
          )}
          {activeGeocontext?.enable_donations_text && (
            <div
              className={classNames('mt-3', styles.ListItemMenu)}
              onClick={() => setDonationModal(true)}
            >
              <Donation className="me-3" /> {t('MENU_DONATIONS')}
            </div>
          )}
          <div
            className={classNames('mt-3', styles.ListItemMenu)}
            onClick={() => setPresentazione(true)}
          >
            <Tutorial className="me-3" /> {t('MENU_TUTORIAL')}
          </div>
          <div
            className={classNames('mt-3', styles.ListItemMenu)}
            onClick={() => setInfoWiki(true)}
          >
            <LogoMenu className="me-3" /> {t('MENU_WHAT_IS_WLM')}
          </div>
          <div
            className={classNames('mt-3', styles.ListItemMenu)}
            onClick={() => setShowCredits(true)}
          >
            <Credits className="me-3" /> {t('GENERIC_CREDITS')}
          </div>
        </div>
        <div className="pt-4 border-top border-white">
          <div className="d-flex align-items-center justify-content-end">
            <div
              className={styles.ListItemMenu}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                if (username) {
                  logout()
                } else {
                  setShowLicenseModal(true)
                }
              }}
            >
              <LoginWhite className="me-3" />{' '}
              {username ? t('GENERIC_LOGOUT') : t('GENERIC_LOGIN')}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
